module.exports = __webpack_public_path__ + "img/dt-colored-logotype.cdddc2e1.png";